module.exports = __webpack_public_path__ + "static/img/PortusFin.3b689a4d.png";